// extracted by mini-css-extract-plugin
export var container = "recipe-modal-module--container--CsRNv";
export var loader = "recipe-modal-module--loader--SeGGM";
export var modal = "recipe-modal-module--modal--zxIxP";
export var notes = "recipe-modal-module--notes--Zowmx";